import { connect } from 'react-redux'
import React from 'react'
import Checkout from '../pages/checkout/Checkout'

const CheckoutPage = ({ params, location }) => (
  <div className='s_p_a'>
    <Checkout action='login' key='checkout' viewParams={{ ...params, query: location.query }} />
  </div>
)

export default connect()(CheckoutPage)
